import { get } from 'lodash/object'
import routes from '~/const/routes'
import { PLAN_TYPES } from '~/modules/billing/constants/common'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null,
  invoice: null,
  shouldShowTrialModal: false,
  balance: null,
  periods: [],
  changeTabIndex: null,
  activities: null,
  consumptions: null,
  expiresAt: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams,
  shouldShowTrialModal: state => state.shouldShowTrialModal,
  activities: state => state.activities,
  balance: state => state.balance,
  invoice: state => state.invoice,
  periods: state => state.periods,
  currentPlan: state => state.periods.find(period => period.type === PLAN_TYPES.tariff),
  expiresAt: state => state.expiresAt,
  additionalDocuments: state =>
    state.periods.filter(period => [PLAN_TYPES.document, PLAN_TYPES.bonus].includes(period.type)),
  changeTabIndex: state => state.changeTabIndex,
  consumptions: state => state.consumptions
}

export const mutations = {
  SET_SHOULD_SHOW_TRIAL_MODAL(state, flag) {
    state.shouldShowTrialModal = flag
  },
  UPDATE_TRIAL_STATUS(state, status) {
    state.trialStatus = status
  },
  SET_ACTIVITIES(state, payload) {
    state.activities = payload
  },
  SET_INVOICE(state, invoice) {
    state.invoice = invoice
  },
  SET_BALANCE(state, balance) {
    state.balance = balance
  },
  SET_PERIODS(state, periods) {
    state.periods = periods
  },
  SET_EXPIRES_AT(state, expiresAt) {
    state.expiresAt = expiresAt
  },
  SET_CHANGE_TAB_INDEX(state, tabIndex) {
    state.changeTabIndex = tabIndex
  },
  SET_CONSUMPTIONS(state, consumptions) {
    state.consumptions = consumptions
  },
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.invoice = null
    state.shouldShowTrialModal = false
    state.balance = null
    state.periods = []
    state.changeTabIndex = null
    state.consumptions = null
    state.expiresAt = null
  }
}

export const actions = {
  async getAll({ commit }, { config = {} }) {
    const { data, meta } = get(await this.$axios.get(routes.billing.list(), config), 'data')

    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'billing',
        items: data,
        meta,
        params: config.params
      },
      { root: true }
    )

    return { data, meta }
  },
  // роут якій показує чи потрібно показувати модалку для активації trial після відповідей на onboarding
  async updateTrialModalStatus({ commit }) {
    const { data } = await this.$axios.get(routes.billing.trial())

    const update = get(data, 'result')

    commit('SET_SHOULD_SHOW_TRIAL_MODAL', update)
  },
  async trialActivation() {
    const { data } = await this.$axios.post(routes.billing.trial())
    return data
  },
  async getDashboardData({ commit }) {
    const { data } = await this.$axios.get(routes.billing.dashboard(), {})

    commit('SET_BALANCE', get(data, 'balance'))
    commit('SET_PERIODS', get(data, 'periods'))
    commit('SET_INVOICE', get(data, 'invoice'))
    commit('SET_EXPIRES_AT', get(data, 'expiresAt'))

    return data
  },
  async purchase({ commit }, { payload }) {
    const { data } = await this.$axios.post(routes.billing.purchase(), payload)

    return data
  },
  async getPlans() {
    const { data } = await this.$axios.get(routes.billing.tariffs())
    return data
  },
  async fetchActivities({ commit }) {
    const { data } = await this.$axios.get(routes.billing.activities())
    commit('SET_ACTIVITIES', get(data, 'result', data))
  },
  async getConsumptions({ commit }) {
    const { data } = await this.$axios.get(routes.billing.consumptions())

    commit('SET_CONSUMPTIONS', data)
    return data
  },
  async adminCreatePeriod({ commit }, payload) {
    const { data } = await this.$axios.post(routes.billing.apply(), payload)

    return data
  }
}
